import { registerVariants } from '@/components/templates/RegisterUserTemplate/useRegisterValiant';
import { useRuntimeConfig } from 'theme/composables/useRuntimeConfig';
import { computed } from 'vue';
import { CHANNEL_ID_MAP } from '~/entity/channel';

export function useCvButtonNavigation() {
  const env = useRuntimeConfig().public.serverEnv;

  const cvButtonTo = computed(() => {
    const targetPlannerId = ['production', 'staging'].includes(env) ? 2694 : 7;

    return {
      path: '/register',
      query: {
        redirect: `/planner/${targetPlannerId}/matching`,
        inflow_channel: CHANNEL_ID_MAP.FOUR_HUNDRED_F,
        register_variant: registerVariants.lp400F,
      },
    };
  });

  return {
    cvButtonTo,
  };
}
